export const EDIT_RESOURCE_FORM = 'edit-resource-form';
